import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class AuthenticatedPlanningForCollegeIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    // The section has no landing page of its own, and unlike its siblings it is
    // not in the sidebar — so this follows router order and lands on the first
    // declared child.
    this.router.replaceWith('authenticated.planning-for-college.scholarship');
  }
}
